import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Order } from "../types";
import { fetchOrders } from "../services/orderService";
import Loader from "../components/loader/Loader";
import { useUserStore } from "../store/userStore";
import { addToCart } from "../services/cartService";

const ProfilePage = () => {
  const [orders, setOrders] = useState<Order[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  //get goken from local storage
  const token = localStorage.getItem("token");

  useEffect(() => {

    // Fix for ProfilePage error handling
    const loadOrders = async () => {
      try {
        if (!token) {
          navigate("/auth");
        } else {
          const fetchedOrders = await fetchOrders();
          setOrders(fetchedOrders);
        }
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : "Неизвестная ошибка";
        setError(errorMessage);
      }
    };
    loadOrders();
  }, [token, navigate]);

  const getStatusLabel = (status: string) => {
    switch (status) {
      case "pending":
        return "Оформление заказа"; 
      case "processing":
        return "Обработка";
      case "shipped":
        return "Отправлен";
      case "delivered":
        return "Выдан";
      case "canceled":
        return "Отменен";
      case "returned":
        return "Возврат";
      default:
        return status;
    }
  };

  const handleOrderDetails = (orderId: number) => {
    navigate(`/order/${orderId}`);
  };

  // Повторяем заказ — добавляем товары в корзину и уводим на страницу корзины
  const handleRepeatOrder = async (order: Order) => {
    try {
      // Проходимся по всем товарам и добавляем их
      order.items && order.items.forEach(async (item) => {
        await addToCart(item.product_id, item.quantity);
      });
      // for (const item of order.items) {
      //   await addToCart(item.product_id, item.quantity);
      // }
      // После добавления в корзину можно освежить локальный стейт корзины
      // (если у вас есть метод refreshCartFromServer() или что-то подобное)
      // Или setCart(...) если нужно
      // ...
      // Переходим в корзину
      navigate("/cart");
    } catch (err) {
      console.error("Ошибка при повторном заказе:", err);
    }
  };

  const handleLogout = () => {
    useUserStore.getState().clearUser();
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("uname");
    localStorage.removeItem("uphone");
    navigate('/auth');
  };

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-xl font-semibold mb-4">Мои заказы</h2>
      {orders === null ? (
        <Loader />
      ) : orders.length === 0 ? (
        <div>У вас нет заказов</div>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {orders.map((order) => (
            <div
              key={order.id}
              className="border p-4 flex md:justify-between md:items-center md:flex-row flex-col"
            >
              <div>
                <h3 className="font-bold">Заказ №{order.id}</h3>
                <p>Статус: <b>{getStatusLabel(order.status)}</b></p>
                <p>Сумма: {order.total_amount} ₸</p>
              </div>
              <div className="flex space-x-2 md:mt-0 mt-4">
                {/* Кнопка "Подробнее" */}
                <button
                  className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300"
                  onClick={() => handleOrderDetails(order.id)}
                >
                  Подробнее
                </button>
                {/* Кнопка "Повторить заказ" */}
                <button
                  className="px-4 py-2 border  rounded hover:bg-pink-300"
                  onClick={() => handleRepeatOrder(order)}
                >
                  Повторить заказ
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        onClick={handleLogout}
        className="w-full bg-black mt-5 text-white py-2 rounded-lg hover:bg-stone-800 transition"
      >
        Выйти
      </button>
    </div>
  );
};

export default ProfilePage;